<template>
  <nav class="" data-scroll="true">
    <div class="cabecera text-analiza-light" id="navcabecera">
      <div class="left">
        <p class="text-dark px-4">{{ calcularTextoCabecera }}</p>
      </div>
      <div class="right">
        <a class="mt-3 me-3 p-0 nav-link text-analiza-dark bg-analiza-medium" href="https://analiza360.es/contacto/" target="_blank">
          <i class="fa fa-headset" aria-hidden="true"></i>
        </a>
        <a class="mt-3 p-0 nav-link text-analiza-dark bg-analiza-medium" @click="mostrarAvisos()">
          <i class="fa fa-bell" aria-hidden="true"></i>
        </a>
      </div>
    </div>
  </nav>
</template>

<script>
  export default {
    name: "NavCabecera",
    data() {
      return {
      };
    },
    created() {
    },
    methods: {  
      async mostrarAvisos() {
        
      },
      async irConfiguracion() {
        this.$router.push("/profile");
      } 
    },
    components: {
    },
    computed: {
      calcularTextoCabecera() {
        const nombre = this.$store.state.profile.permisos?.farmaciaNombre ? 'Farmacia ' + this.$store.state.profile.permisos.farmaciaNombre : this.$store.state.profile.permisos?.empresaNombre;
        if (!nombre && this.$store.state.profile.permisos?.isAdmin==1) {
          return 'Hola ' + this.$store.state.profile.permisos.nombre;
        }
        return nombre;
      }
    },
    updated() {
    },
  };
</script>
